import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

class StructuralOverviewComponentForm extends Form {
	state = {
		data: {
			name: '',
			description: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		name: Joi.string().min(2).required().label('Component'),
		description: Joi.string().min(3).required().label('Description'),
	};

	static propTypes = {
		onSave: PropTypes.func,
	};

	doSubmit = (): void => {
		this.props.onSave({
			name: this.state.data.name,
			description: this.state.data.description,
		});

		this.setState({ data: { name: '', description: '' } });

		toastService.success('Structural Component Added Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderInput({
					type: 'text',
					name: 'name',
					placeholder: 'Enter Component Name e.g South Pipe Rack',
					label: 'Component',
				})}

				<div className="my-4 divider"></div>

				{this.renderTextArea({
					name: 'description',
					placeholder: 'Enter a short description of the component',
					label: 'Description',
					rows: '4',
				})}

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Add Component')}
				</div>
			</form>
		);
	}
}

export default StructuralOverviewComponentForm;
